// Configurações por contexto para drill down de transações
export interface DrillDownConfig {
  partnerLabel: string;
  partnerPluralLabel: string;
  transactionLabel: string;
  valueLabel: string;
  chartTitle: string;
  productsSectionTitle: string;
  dailyEvolutionTitle: string;
  periodSummaryLabels: {
    totalValue: string;
    totalDocuments: string;
    totalPartners: string;
    totalProducts: string;
    ticketMedio: string;
    maiorTransacao: string;
    menorTransacao: string;
  };
  valueKeys: {
    transactionValue: string;
    partnerValue: string;
    productValue: string;
    dailyValue: string;
    activePartners: string;
  };
  colors: {
    primary: string;
    secondary: string;
  };
}

export const DRILL_DOWN_CONFIGS: Record<string, DrillDownConfig> = {
  compras: {
    partnerLabel: 'Fornecedor',
    partnerPluralLabel: 'Fornecedores',
    transactionLabel: 'Compras',
    valueLabel: 'Valor Compras',
    chartTitle: 'Top 10 Fornecedores do Período',
    productsSectionTitle: 'Principais Produtos do Período',
    dailyEvolutionTitle: 'Evolução Diária das Compras',
    periodSummaryLabels: {
      totalValue: 'Total Compras',
      totalDocuments: 'Total Documentos',
      totalPartners: 'Total Fornecedores',
      totalProducts: 'Total Produtos',
      ticketMedio: 'Ticket Médio',
      maiorTransacao: 'Maior Compra',
      menorTransacao: 'Menor Compra'
    },
    valueKeys: {
      transactionValue: 'total_compras',
      partnerValue: 'valor_compras',
      productValue: 'valor_compras',
      dailyValue: 'valor_compras',
      activePartners: 'fornecedores_ativos'
    },
    colors: {
      primary: '#1976d2',
      secondary: '#42a5f5'
    }
  },
  vendas: {
    partnerLabel: 'Cliente',
    partnerPluralLabel: 'Clientes',
    transactionLabel: 'Vendas',
    valueLabel: 'Valor Vendas',
    chartTitle: 'Top 10 Clientes do Período',
    productsSectionTitle: 'Produtos Mais Vendidos do Período',
    dailyEvolutionTitle: 'Evolução Diária das Vendas',
    periodSummaryLabels: {
      totalValue: 'Total Vendas',
      totalDocuments: 'Total Documentos',
      totalPartners: 'Total Clientes',
      totalProducts: 'Total Produtos',
      ticketMedio: 'Ticket Médio',
      maiorTransacao: 'Maior Venda',
      menorTransacao: 'Menor Venda'
    },
    valueKeys: {
      transactionValue: 'total_vendas',
      partnerValue: 'valor_vendas',
      productValue: 'valor_vendas',
      dailyValue: 'valor_vendas',
      activePartners: 'clientes_ativos'
    },
    colors: {
      primary: '#3366CC',
      secondary: '#5588DD'
    }
  }
};

// Função utilitária para obter configuração
export const getDrillDownConfig = (transactionType: 'compras' | 'vendas'): DrillDownConfig => {
  const config = DRILL_DOWN_CONFIGS[transactionType];
  if (!config) {
    throw new Error(`Configuração não encontrada para tipo de transação: ${transactionType}`);
  }
  return config;
}; 